import { first, last, } from 'remeda';
export function getSlices({ page, // human page, starts with 1
limit, }, ...pageProps) {
    let resultStart = (page - 1) * limit;
    let resultEnd = resultStart + limit;
    const result = [];
    let isEnough = false;
    for (const pageProp of pageProps) {
        if (isEnough) {
            result.push('do not use');
            continue;
        }
        if (resultEnd <= pageProp.count) { // fit fully
            result.push({
                start: resultStart,
                end: resultEnd,
            });
            isEnough = true;
            continue;
        }
        if (resultStart < pageProp.count && pageProp.count <= resultEnd) { // partially
            result.push({
                start: resultStart,
                end: pageProp.count,
            });
            resultStart = 0;
            resultEnd = resultEnd - pageProp.count;
            continue;
        }
        /* istanbul ignore else */
        if (resultStart >= pageProp.count) { // no items for page
            resultStart = resultStart - pageProp.count;
            resultEnd = resultEnd - pageProp.count;
            result.push('do not use');
        }
    }
    return result;
}
export function getPageControls({ page, totalPages, maxPages }) {
    const pages = [{ type: 'page', page }];
    let direction = 'prepend';
    const needPages = Math.min(maxPages, totalPages);
    // fill up the pages from left and right until
    // there are enough pages
    while (pages.length < needPages) {
        const f = first(pages)?.page;
        const l = last(pages)?.page;
        // prepend until we reach the start
        if (direction === 'prepend' && f > 1) {
            pages.unshift({ type: 'page', page: f - 1 });
        }
        // append until we reach the end
        if (direction === 'append' && l < totalPages) {
            pages.push({ type: 'page', page: l + 1 });
        }
        direction = direction === 'prepend' ? 'append' : 'prepend';
    }
    if (page > 1) {
        // if we are not reached the beginning,
        // add ellipses and replace the first page
        if (pages[0]?.page !== 1) {
            pages.splice(0, 2, { type: 'page', page: 1 }, { type: '...', page: -1 });
        }
        pages.unshift({ type: 'previous', page: page - 1 });
    }
    if (page < totalPages) {
        // same for the end
        if (pages[pages.length - 2]?.page !== totalPages - 1) {
            pages.splice(pages.length - 2, 2, { type: '...', page: -1 }, { type: 'page', page: totalPages });
        }
        pages.push({ type: 'next', page: page + 1 });
    }
    return pages;
}
//# sourceMappingURL=PagingUtils.js.map